import { ZigzinProduct } from '../components/ZigzinProduct';
import { useShippingZigzinProductService } from '../services/useShippingZigzinProductService';

export const ShippingZigzinProductContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useShippingZigzinProductService();

  if (!service.shippingInfo) {
    return null;
  }
  return <ZigzinProduct {...service} shippingInfo={service.shippingInfo} />;
};
